
import battleship from '../assets/attack-page.png';
import tictactoe from '../assets/tictactoe.png';
import weather from '../assets/weather.png';
import odinsOperations from '../assets/odinsOperations.png';
import calculator from '../assets/calculator.png';
import shopping from '../assets/shopping.png';

const ProjectInfo = {

  project: [{
      name: 'Battleship', 
      images: battleship, 
      description: 'Battleship game',
      githubURL: 'https://github.com/TechnicolorPanda/battleship',
      liveDemo: 'https://technicolorpanda.github.io/battleship/',
      id: 3323,
    },
    {
      name: 'Tic-Tac-Toe',
      images: tictactoe,
      description: 'Tic-Tac-Toe game',
      githubURL: 'https://github.com/TechnicolorPanda/tic-tac-toe',
      liveDemo: 'https://technicolorpanda.github.io/tic-tac-toe/',
      id: 8479,
    },
    {
      name: 'Weather App',
      images: weather,
      description: 'Weather application',
      githubURL: 'https://github.com/TechnicolorPanda/weather-app',
      liveDemo: 'https://technicolorpanda.github.io/weather-app/',
      id: 9183,
    },
    {
      name: 'Odin\'s Operations',
      images: odinsOperations,
      description: 'Game Jam 2021 Team Entry',
      githubURL: 'https://github.com/TechnicolorPanda/odins-operations',
      liveDemo: 'https://technicolorpanda.github.io/odins-operations/',
      id: 7683,
    },
    {
      name: 'Calculator',
      images: calculator,
      description: 'A basic calculator',
      githubURL: 'https://github.com/TechnicolorPanda/calculator',
      liveDemo: 'https://technicolorpanda.github.io/calculator/',
      id: 2345,
    },
    {
      name: 'Shopping Site',
      images: shopping,
      description: 'A basic e-commerce site',
      githubURL: 'https://github.com/TechnicolorPanda/shopping-cart',
      liveDemo: 'https://technicolorpanda.github.io/shopping-cart/',
      id: 8129,
    }
  ]
}

  export default ProjectInfo;